/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Fmt_TitleInputs */

const en_vc_fmt_title = /** @type {(inputs: Vc_Fmt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your files, export what you need`)
};

const zh_vc_fmt_title = /** @type {(inputs: Vc_Fmt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开你的文件，导出你要的格式`)
};

/**
* | output |
* | --- |
* | "Open your files, export what you need" |
*
* @param {Vc_Fmt_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_fmt_title = /** @type {((inputs?: Vc_Fmt_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Fmt_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_fmt_title(inputs)
	return zh_vc_fmt_title(inputs)
});
export { vc_fmt_title as "vc.fmt.title" }